export default __webpack_public_path__ + "static/media/ratings-form.b95ed464.PNG";